<template>
  <!--Evento emitido ao clicar no card 
      @event click
   -->
  <z-card
    :class="classes"
    :width="width"
    :shadow="shadow"
    v-bind="$attrs"
    @click.native="$emit('click')"
  >
    <template #content>
      <div
        class="content-wrapper"
        :class="{'has-action': $scopedSlots['action']}"
      >
        <div class="icon-container">
          <v-avatar v-if="src" size="64" class="card-icon">
            <img :src="src" />
          </v-avatar>

          <v-icon
            v-else-if="icon"
            :color="iconColor"
            size="64"
            class="card-icon"
          >
            {{ icon }}
          </v-icon>
        </div>

        <div :class="{'card-content': true, [align]: true}">
          <div class="card-title">
            {{ title }}
          </div>

          <div class="card-description">
            {{ description }}
          </div>
        </div>

        <div v-if="$scopedSlots['action']" class="action">
          <!--@slot Slot de ações do card -->
          <slot name="action"></slot>
        </div>
      </div>

      <div v-if="$scopedSlots['default']">
        <!--@slot Slot default do componente -->
        <slot></slot>
      </div>
    </template>
  </z-card>
</template>

<script>
/**
 * @displayName Card Selection
 */
export default {
  name: 'ZCardSelection',
  props: {
    /**
     * SRC do avatar, caso seja passado será usado o avatar
     */
    src: {
      type: String,
      required: false,
      default: '',
    },
    /**
     * ìcone para ser utilizado
     */
    icon: {
      type: String,
      required: false,
      default: '',
    },
    /**
     * Cor do ícone a ser utilizado
     */
    iconColor: {
      type: String,
      required: false,
      default: '',
    },
    /**
     * Título utilizado no card
     */
    title: {
      type: String,
      required: true,
    },
    /**
     * Descrição do card
     */
    description: {
      type: String,
      required: false,
      default: '',
    },
    /**
     * Alinhamento do conteúdo do card (start, end ou center)
     */
    align: {
      type: String,
      required: false,
      default: 'start',
    },

    /**
     * Largura do card
     */
    width: {
      type: [String, Number],
      required: false,
      default: '100%',
    },
    /**
     * Aplica sombra ao card
     */
    shadow: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        'zoox-component': true,
        'zoox-card-selection': true,
        'has-click-event': this.$listeners && this.$listeners.click,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.zoox-card-selection {
  display: grid;
  border-radius: var(--component-card-radius) !important;
  padding: 10px;
  gap: 15px;
  align-items: center;
  grid-template-columns: auto;

  .content-wrapper {
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    gap: 15px;

    &.has-action {
      grid-template-columns: 84px 1fr auto;
    }
  }

  .card-content {
    .card-description {
      font-weight: 400;
      color: var(--black-600);
      font-size: 0.9375rem;
    }

    &.start {
      text-align: start;
    }

    &.end {
      text-align: end;
    }

    &.center {
      text-align: center;
    }
  }

  &.has-click-event {
    cursor: pointer;
  }
}
</style>
